import { Box, Stack, Typography, Button } from "@mui/material";
import { LargeCustomIcon } from "../../layer00";
import thinkingRobot from "../../../../assets/images/thinkingRobot.png";

export type PrepSupportNeedCardProps = {
  content: string;
};

export const PrepSupportNeedCard = (props: PrepSupportNeedCardProps) => {
  return (
    <Box
      padding="1.5rem"
      borderRadius="1rem"
      display="flex"
      flexDirection={{
        xs: "column",
        sm: "row",
      }}
      gap="1.5rem"
      className="bg-team-app-gradient-stripe-light"
      sx={{
        minWidth: {
          xs: "auto",
          sm: "22.5rem",
        },
      }}
    >
      <Box
        component="img"
        src={thinkingRobot}
        sx={{
          width: "6.625rem",
          height: "5.4375rem",
          aspectRatio: 106 / 87,
        }}
      />
      <Stack direction="column" rowGap=".5rem">
        <Typography
          variant="h5"
          className="text-navy-100"
          sx={{
            fontSize: "1rem",
            fontWeight: 600,
            lineHeight: "1.5rem",
          }}
        >
          Support Needs
        </Typography>
        <Typography
          variant="body1"
          className="text-sapphire-150"
          sx={{
            lineHeight: "1.125rem",
          }}
        >
          {props.content}
        </Typography>
      </Stack>
      <Box>
        <Button
          sx={{
            height: "2.5rem",
            width: "fit-content",
            inlineSize: "fit-content",
            whiteSpace: "nowrap",
            textTransform: "none",
            textWrap: "nowrap",
          }}
          startIcon={<LargeCustomIcon icon="SPARKLE" />}
          variant="outlined"
        >
          Let&apos;s Chat
        </Button>
      </Box>
    </Box>
  );
};
